module.exports = {"310117001":"岳阳街道","310117002":"永丰街道","310117003":"方松街道","310117004":"中山街道","310117005":"广富林街道","310117006":"九里亭街道","310117102":"泗泾镇","310117103":"佘山镇","310117104":"车墩镇","310117105":"新桥镇","310117106":"洞泾镇","310117107":"九亭镇","310117109":"泖港镇","310117116":"石湖荡镇","310117117":"新浜镇","310117120":"叶榭镇","310117121":"小昆山镇","310117501":"松江工业区","310117504":"佘山度假区","310117507":"上海松江出口加工区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310117.json
// module id = 920
// module chunks = 0